"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function objectAssign(target) {
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        rest[_i - 1] = arguments[_i];
    }
    if (target == null) {
        throw new TypeError("Cannot convert undefined or null to object");
    }
    var to = Object(target);
    for (var _a = 0, rest_1 = rest; _a < rest_1.length; _a++) {
        var nextSource = rest_1[_a];
        if (nextSource != null) {
            // Skip over if undefined or null
            for (var nextKey in nextSource) {
                // Avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                    to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function transform(props) {
    return props;
}
exports.transform = transform;
function assign(a, b) {
    return objectAssign(a, b);
}
exports.assign = assign;
var Component = /** @class */ (function () {
    function Component() {
        this.props = [];
        this.template = "";
        this.methods = {};
        this.events = {};
        this.name = "";
        this.assign = assign;
    }
    Component.prototype.transform = function (props) {
        return props;
    };
    return Component;
}());
exports.Component = Component;
assign(Component, { assign: assign, transform: transform });
exports.default = Component;
